import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';
import { getAccessToken } from '../../core/auth';
import { createUploadLink } from 'apollo-upload-client';
    

const uploadLink = createUploadLink({
    uri: process.env.REACT_APP_Back_End_Api_Url
})
const authLink = setContext((_, { headers }) => {
    const token = getAccessToken();
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : ''
        }
    }
})
export const client = new ApolloClient({
    link: authLink.concat(uploadLink),
    cache: new InMemoryCache()
});